export default __webpack_public_path__ + "static/media/Ies_Zeraus.01a3d343.png";